import { CookiesSection1 } from '@/components/legal/CookiesSection1';
import { CookiesSection2 } from '@/components/legal/CookiesSection2';
import { CookiesSection3 } from '@/components/legal/CookiesSection3';

export const CookiesPolicyContent = () => {
  return (
    <div className="space-y-8">
      <CookiesSection1 />
      <CookiesSection2 />
      <CookiesSection3 />
    </div>
  );
};
